import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase';
import HomePage from '../views/HomePage.vue';
// import TeamPage from '../views/TeamPage.vue';

// import { onAuthStateInit } from '../main.js'

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutPage.vue'),
    },
    {
        path: '/team',
        name: 'Team',
        component: () => import(/* webpackPrefetch: true */ '../views/TeamPage.vue'),
    },
    {
        path: '/curriculum',
        name: 'Database',
        component: () => import(/* webpackChunkName: "about" */ '../views/DatabasePage.vue'),
    },
    {
        path: '/partners',
        name: 'Partner',
        component: () => import(/* webpackChunkName: "about" */ '../views/PartnerPage.vue'),
    },
    {
        path: '/user',
        name: 'User',
        component: () => import(/* webpackChunkName: "about" */ '../views/UserPage.vue'),
        meta: {
            hideForAuth: true,
        },
    },
    {
        path: '/signup',
        name: 'SignUp',
        component: () => import(/* webpackChunkName: "about" */ '../views/SignUpPage.vue'),
        meta: {
            hideForAuth: true,
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/LoginPage.vue'),
        meta: {
            hideForAuth: true,
        },
    },
    {
        path: '/profile',
        name: 'Profile',
        component: () => import(
            /* webpackChunkName: "about" */ '../views/ProfilePage.vue'
        ),
        meta: {
            authRequired: true,
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    // from https://stackoverflow.com/questions/63047603/attempting-to-make-firebase-auth-currentuser-a-promise
    const onAuthStateChangedPromise = new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged((user) => {
        //   store.commit(user !== null ? 'LOGIN' : 'LOGOUT', user)
            resolve(user);
        }, (err) => {
            reject(err);
        });
    });
    const onAuthStateInit = () => onAuthStateChangedPromise;
    await onAuthStateInit();

    console.log('this is the firebase auth: ', firebase.auth().currentUser);
    if (to.matched.some((record) => record.meta.authRequired)) {
        if (firebase.auth().currentUser) {
            next();
        } else {
            // eslint-disable-next-line no-alert
            console.log('You must be logged in to see this page');
            next({
                path: '/user',
            });
        }
    } else if (to.matched.some((record) => record.meta.hideForAuth)) {
        if (firebase.auth().currentUser) {
            console.log('should reroute to profile');
            next({
                path: '/profile',
            });
        } else {
            console.log('not logged in so this is a valid page');
            next();
        }
    } else {
        next();
    }
});

export default router;
